import React from 'react';
import { Link } from '@bibliocommons/base-links';
import { cardShape } from '@bibliocommons/bc-prop-types';

import './EventLocation.scss';

export default function EventLocation({ card }) {
  if (card.get('location')) {
    return (
      <Link href={card.getIn(['location', 'url'])} className="cp-event-location" dataKey="event-location-link">
        {card.getIn(['location', 'name'])}
      </Link>
    );
  }

  return null;
}

EventLocation.propTypes = {
  card: cardShape.isRequired
};
